import { render, staticRenderFns } from "./AlertFormDialog.vue?vue&type=template&id=d5960efc&scoped=true"
import script from "./AlertFormDialog.vue?vue&type=script&lang=js"
export * from "./AlertFormDialog.vue?vue&type=script&lang=js"
import style0 from "./AlertFormDialog.vue?vue&type=style&index=0&id=d5960efc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5960efc",
  null
  
)

export default component.exports